import React from 'react';
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function CrmDashboard() {
  const user = useSelector((state) => state.authState?.user);

  const followUps = [
    { id: 1, time: '10:00 AM', name: 'Rahul Verma', status: 'Interested' },
    { id: 2, time: '11:30 AM', name: 'Pooja Singh', status: 'Call Back' },
    { id: 3, time: '02:00 PM', name: 'Aman Khan', status: 'Visit Scheduled' },
  ];

  const notices = [
    '5 new enquiries received today',
    'Follow up pending for 12 leads',
    'Update admission conversion status',
  ];

  return (
    <div className='container-fluid py-4'>
      <div className='d-flex justify-content-between align-items-center mb-4'>
        <div>
          <h4 className='fw-bold text-dark mb-1'>
            Welcome,{' '}
            <span className='text-primary'>{user?.user_name || 'CRM User'}</span>
          </h4>
          <p className='text-muted m-0'>Here is your CRM dashboard</p>
        </div>

        <div>
          <span className='badge bg-light text-dark px-3 py-2 rounded-pill'>
            CRM
          </span>
        </div>
      </div>

      <Row className='g-4 mb-4'>
        <Col sm='6' lg='3'>
          <div className='card border-0 shadow-sm rounded-4 p-4 h-100'>
            <div className='d-flex align-items-center justify-content-between'>
              <i
                className='bi bi-person-plus-fill text-primary'
                style={{ fontSize: '3rem' }}
              ></i>
              <div className='text-end'>
                <h6 className='text-muted text-uppercase fw-semibold mb-1'>
                  New Leads
                </h6>
                <h2 className='fw-bold mb-0'>12</h2>
              </div>
            </div>
          </div>
        </Col>

        <Col sm='6' lg='3'>
          <div className='card border-0 shadow-sm rounded-4 p-4 h-100'>
            <div className='d-flex align-items-center justify-content-between'>
              <i
                className='bi bi-telephone-fill text-success'
                style={{ fontSize: '3rem' }}
              ></i>
              <div className='text-end'>
                <h6 className='text-muted text-uppercase fw-semibold mb-1'>
                  Follow-ups Today
                </h6>
                <h2 className='fw-bold mb-0'>8</h2>
              </div>
            </div>
          </div>
        </Col>

        <Col sm='6' lg='3'>
          <div className='card border-0 shadow-sm rounded-4 p-4 h-100'>
            <div className='d-flex align-items-center justify-content-between'>
              <i
                className='bi bi-check-circle-fill text-warning'
                style={{ fontSize: '3rem' }}
              ></i>
              <div className='text-end'>
                <h6 className='text-muted text-uppercase fw-semibold mb-1'>
                  Converted
                </h6>
                <h2 className='fw-bold mb-0'>4</h2>
              </div>
            </div>
          </div>
        </Col>

        <Col sm='6' lg='3'>
          <div className='card border-0 shadow-sm rounded-4 p-4 h-100'>
            <div className='d-flex align-items-center justify-content-between'>
              <i
                className='bi bi-hourglass-split text-danger'
                style={{ fontSize: '3rem' }}
              ></i>
              <div className='text-end'>
                <h6 className='text-muted text-uppercase fw-semibold mb-1'>
                  Pending Leads
                </h6>
                <h2 className='fw-bold mb-0'>17</h2>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Row className='g-4'>
        <Col lg='8'>
          <div className='card border-0 shadow-sm rounded-4 p-4 h-100'>
            <h5 className='fw-bold mb-3'>
              <i className='bi bi-calendar-check text-primary me-2'></i>
              Today Follow-up Schedule
            </h5>

            <div className='table-responsive'>
              <table className='table align-middle'>
                <thead>
                  <tr>
                    <th>Time</th>
                    <th>Name</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {followUps.map((item) => (
                    <tr key={item.id}>
                      <td>{item.time}</td>
                      <td>{item.name}</td>
                      <td>{item.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Col>

        <Col lg='4'>
          <div className='card border-0 shadow-sm rounded-4 p-4 mb-4'>
            <h5 className='fw-bold mb-3'>Quick Links</h5>
            <div className='d-grid gap-2'>
              <Link
                to='/new-leads'
                className='btn btn-outline-primary btn-sm'
              >
                Leads Master
              </Link>
              <Link
                to='/follow-up-list'
                className='btn btn-outline-success btn-sm'
              >
                Follow-up List
              </Link>
              <Link
                to='/admissions'
                className='btn btn-outline-warning btn-sm'
              >
                Admission Enquiry
              </Link>
            </div>
          </div>

          <div className='card border-0 shadow-sm rounded-4 p-4'>
            <h5 className='fw-bold mb-3'>Notices</h5>
            <ul className='list-group list-group-flush small'>
              {notices.map((item, index) => (
                <li key={index} className='list-group-item px-0'>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </Col>
      </Row>
    </div>
  );
}